<template>
  <div class="profile-container">
    <div class="flex">
      <template v-if="orders && orders.length">
        <div
          @click="chooseOrder(order)"
          v-for="order in orders"
          :key="order.order_id"
          class="order-card"
        >
          <order-row :order="order"></order-row>
        </div>
      </template>
      <template v-else>
        {{ "profile.titles.no_orders" | translate }}
      </template>
      <order-view v-if="chosenOrder" :order="chosenOrder"></order-view>
    </div>
  </div>
</template>

<script>
import OrderRow from "../molecules/order-row.vue";
import OrderView from "../molecules/order-view.vue";
export default {
  name: "profile-orders",
  components: { OrderRow, OrderView },
  props: { orders: Array },
  data() {
    return {
      chosenOrder: null
    };
  },
  methods: {
    chooseOrder(order) {
      this.chosenOrder = order;
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/global.scss";
.content-container {
  background-color: $brand-gray-light;
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}

h1 {
  text-align: center;
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.flex {
  flex-wrap: wrap;
  margin: 0 -0.5rem;
}

.order-card {
  width: 50%;
  margin-bottom: 1.5rem;
  padding: 0.5rem;

  @media (min-width: $breakpoint-md) {
    width: 33.3%;
  }

  @media (min-width: $breakpoint-lg) {
    width: 25%;
  }
}
</style>
